import {environment} from '../../../environments/environment';

export class Logger {
    private static originalConsoleLog = console.log;


    // allow controlling the console log behavior via boolean enableConsoleLog environment variable
    // note: place Logger.overrideConsoleLog() in main.ts before platformBrowserDynamic().bootstrapModule(AppModule)
    static overrideConsoleLog(): void {


        if (!(environment as any as { enableConsoleLog: boolean }).enableConsoleLog) {

            if (!(environment as any as { production: boolean }).production) {
                console.warn('Console logging is disabled.');
            }
            console.log = () => {
                // default behavior removed
            };
        }

    }

    static log(...args: any[]): void {

        if ((environment as any as { enableConsoleLog: boolean }).enableConsoleLog) {
            // use the warn method with for better way to find the log place in the code,
            // otherwise the originalConsoleLog points to logger instead the place in the code
            console.warn('%c' + args.join(' '), 'color: white');  // warn with white color to make it look like log as much as possible
        } else {
            Logger.originalConsoleLog.call(console, ...args);
        }
    }

}
